/**
 * Shared SSE context — consumed by both SSEProvider and useSSESubscribe.
 */

import { createContext } from 'react';
import type { CommanderEvent } from '../types/events';

export type SSEEventListener = (event: CommanderEvent) => void;

export interface SSEContextValue {
  isConnected: boolean;
  subscribe: (listener: SSEEventListener) => () => void;
}

export const SSEContext = createContext<SSEContextValue>({
  isConnected: false,
  subscribe: () => () => {},
});
